import axios from 'axios';
import config from '../config';

// Create axios instance with default config
const api = axios.create({
  baseURL: config.app.backend_api_url,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Auth API endpoints
export const authAPI = {
  checkSession: () => api.post('login/sessionavailable', { lo: 1 }),
  signIn: (credentials) => api.post('login/signin', credentials),
  signUp: (userData) => api.post('login/signup', userData),
  forgotPassword: (email) => api.post('login/forgotpassword', { email }),
};

// Groups API endpoints
export const groupsAPI = {
  getById: (group_id) => api.post('groups/getbyid', { group_id }),
  addEditMember: (data) => api.post('groups/add_edit_member', data),
  getGroups: () => api.post('groups/getgroups', { lo: 1 }),
};

// Members API endpoints
export const membersAPI = {
  getProfile: () => api.post('members/getprofile', { lo: 1 }),
  search: (mobile_no, invite_code) => api.post('members/search', { mobile_no, invite_code }),
  updateProfile: (data) => api.post('members/updateprofile', data),
};

// Auction API endpoints
export const auctionAPI = {
  getCurrentAuctionStatus: (invite_code) => api.post('auction/get_current_auction_status_by_invite_code/', { invite_code }),
  getWhatsappMessages: (series_id) => api.post('auction/getwhatsapp_messages', { series_id }),
  getSeriesDetails: (series_id) => api.post('auction/get_series_details', { series_id }),
  createAuction: (data) => api.post('auction/create', data),
  updateAuction: (data) => api.post('auction/update', data),
  updateIsAuctionPrivateFlag: (data) => api.post('Auction/update_is_auction_private_flag', data),
};

// Match Schedule API endpoints
export const scheduleAPI = {
  getMatchSchedules: (group_id) => api.post('matchschedule/getmatchschedules', { lo: 1, group_id }),
  createSchedule: (data) => api.post('matchschedule/create', data),
  updateSchedule: (data) => api.post('matchschedule/update', data),
};

// Attendance API endpoints
export const attendanceAPI = {
  getAttendance: (data) => api.post('attendance/get', data),
  markAttendance: (data) => api.post('attendance/mark', data),
  updateAttendance: (data) => api.post('attendance/update', data),
};

// Team Players API endpoints
export const teamPlayersAPI = {
  getTeamPlayers: (team_id) => api.post('teamplayers/get', { team_id }),
  addPlayer: (data) => api.post('teamplayers/add', data),
  updatePlayer: (data) => api.post('teamplayers/update', data),
};

// Public Registration API endpoints
export const publicRegistrationAPI = {
  getSeriesDetails: (data) => api.post('public_reg/get_series_details', data),
  // Backend expects JSON (with base64 strings for files)
  registerParticipant: (data) => api.post('public_reg/register_participant', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  sendApplicationStatusOTP: (data) => api.post('public_reg/send_application_status_otp', data),
  verifyApplicationStatusOTP: (data) => api.post('public_reg/verify_application_status_otp', data),
};

// Live Auctions API endpoints
export const liveAuctionsAPI = {
  getActiveRecentAuctions: () => api.get('auction/get_active_recent_auctions'),
};

// Series Settings API endpoints
export const seriesSettingsAPI = {
  getSettings: (series_id) => api.post('series_settings/get_settings', { series_id }),
  updateSettings: (data) => api.post('series_settings/update_settings', data),
  bulkUpdateSettings: (data) => api.post('series_settings/bulk_update_settings', data),
};

// Player Details API endpoints
export const playerDetailsAPI = {
  getPlayerDetails: (series_id) => api.post('Player_details/get_player_details', { series_id }),
  updatePlayerDetails: (data) => api.post('Player_details/update_player_details', data),
  getUpdateLogs: (data) => api.post('Player_details/get_update_logs', data),
};

// Public Registration Admin API endpoints
export const publicRegAdminAPI = {
  getComparisonReport: (data) => api.post('public_reg_admin/get_comparison_report', data),
};

// Error handling interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle common errors here
    if (error.response?.status === 401) {
      window.location.replace('sign-in');
    }
    return Promise.reject(error);
  }
);

export default api; 